import styled from '@emotion/styled';
import { SPACER } from 'radiance-ui/lib/constants';

import { desktopOnly } from 'styles/mixins/displayMobileDesktop';
import COLORS from 'styles/constants/colors';

export const AccentCardContainer = styled.div`
  ${desktopOnly()}
  position: relative;
  height: 100%;
  padding-right: ${SPACER.x3large};
`;

export const Chip = styled.span`
  position: absolute;
  bottom: 1rem;
  left: 1rem;
  font-size: 0.75rem;
  font-weight: 700;
  background-color: ${COLORS.surfaceOrange};
  color: ${COLORS.textDefault};
  padding: ${SPACER.xsmall} ${SPACER.small};
`;
